export enum Sport {
    HOCKEY = 'hockey',
    SOCCER = 'soccer',
    FOOTBALL = 'football'
}

export interface ISportConfigModelAPI {
    nbRegulationTimePeriods: number;
    overTimeDurations: string[];
    periodLength: number;
    gameClockGoesDown: boolean;
}

export interface ISportStateModel {
    currentSport: Sport | undefined;
    sportConfig: ISportConfigModelAPI | undefined;
}
